// Same reusable spinner as the driver app. Relies on the @keyframes spin
// animation defined once in index.css.
function LoadingSpinner({ size = 32, fullScreen = false }) {
  const spinner = (
    <div
      style={{
        width: size,
        height: size,
        border: '3px solid #e5e7eb',
        borderTopColor: '#2563eb',
        borderRadius: '50%',
        animation: 'spin 0.7s linear infinite',
      }}
    />
  );

  if (fullScreen) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '50vh',
        }}
      >
        {spinner}
      </div>
    );
  }

  return spinner;
}

export default LoadingSpinner;
